import { ArticleMedia } from 'ui/components/2-molecules/Article';

export const ArticleMediaFeature: React.FC<Umbraco.ArticleMedia> = ({ content }) => <ArticleMedia {...content?.properties} />;
